<template>
  <div>
    <thead>
      <tr>
        <th
          v-for="(item, index) in tableHeaders"
          :key="index"
          :colspan="item.colspan"
          rowspan="2"
        >
          <Sorting
            v-if="item.sorting"
            :item="item"
            :filterable="item.filterable"
            :currentOrderKey="orderBy"
            @order="sortData($event)"
            @filter="sortingFilterHandler($event)"
            @cancelSorting="cancelSorting(item)"
          />
          <span v-else>
            {{ item.name }}
          </span>
        </th>
        <th colspan="10" class="law_enforcement">
          {{ $t('Исполнение законов') }}
        </th>
      </tr>
      <tr>
        <th>
          {{ $t('Норма') }}
        </th>
        <th>
          {{ $t('Ответст. госорган') }}
        </th>
        <th>
          {{ $t('Срок для реал-ции') }}
        </th>
        <th>
          {{ $t('Подзак. акт') }}
        </th>
        <th>
          {{ $t('Нормы') }}
        </th>
        <th>
          {{ $t('ППКР') }}
        </th>
        <th>
          {{ $t('Приказы') }}
        </th>
        <th>
          {{ $t('РПКР') }}
        </th>
        <th>
          {{ $t('Указы') }}
        </th>
        <th>
          {{ $t('Непринято') }}
        </th>
      </tr>
    </thead>
    <tbody>
    <template v-for="item in lawItems">
      <template v-if="item.executionOfLaw != 1 && item.norm.length > 0">
        <tr>
          <td :rowspan="item.norm.length">
            {{ item.id }}
          </td>
          <td :rowspan="item.norm.length">
            <template v-if="user">
              <router-link
                :title="item.transFullName | strippedContent"
                :to="$i18nRoute({name: 'law-view', params: { id: item.id }})"
              >
                {{ item.transFullName }}
              </router-link>
            </template>
            <template v-else>
              {{ item.transFullName }}
            </template>
          </td>

          <td :rowspan="item.norm.length">
            {{  item.adoptionDate }}
          </td>

          <template v-if="item.norm.length > 0">
            <td>
              <span v-if="item.norm.length > 0 && item.norm[0].article">
                Статья {{ item.norm[0].article.number }} <span v-if="item.norm[0].article_part">Ч.{{ item.norm[0].article_part }}</span>
              </span>

              {{ item.norm[0].text }}
              <span class="d-block mt-2" v-if="item.norm[0].law_changes_required && item.norm[0].law_to_change">
                <span class="d-block">Требует внесения изменений в закон:</span>
                <b>
                  <router-link
                    :to="$i18nRoute({name: 'law-view', params: { id: item.norm[0].law_to_change.id }})"
                  >
                    {{item.norm[0].law_to_change.transName}}
                  </router-link>
                </b>
              </span>
            </td>
            <td>
              <div style="display:flex;flex-direction: column;"
                   v-for="developer in item.norm[0].developers" :key="developer.id">
                <div style="display: flex; align-items: center;">
                  <span :class="{ 'font-weight-bold': developer.isMain }">{{ getDeveloperNameById(developer.id) }}</span>
                  <img
                    class="ml-1"
                    v-if="item.norm[0].developers.length > 1 && developer.isMain"
                    width="16"
                    src="@/assets/icons/checked.png"
                  />
                </div>
              </div>
            </td>
            <td>
              <span v-if="item.norm[0].implementationPeriod">
                {{ new Date(item.norm[0].implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
              </span>
            </td>
            <td>
              <span v-if="item.norm[0].byLaw">
                {{ item.norm[0].byLaw.transName }}
              </span>
              <span v-else>
                {{ $t('Нет') }}
              </span>
            </td>
            <td :rowspan="item.norm.length">
              {{ item.allNorms }}
            </td>
            <td :rowspan="item.norm.length">
              <span v-if="item.ppkr > 0">
                {{ item.ppkr }}
              </span>
            </td>
            <td :rowspan="item.norm.length">
              <span v-if="item.prikazy > 0">
                {{ item.prikazy }}
              </span>
            </td>
            <td :rowspan="item.norm.length">
              <span v-if=" item.rpkr > 0">
                {{  item.rpkr }}
              </span>
            </td>
            <td :rowspan="item.norm.length">
              <span v-if="item.ukazy > 0">
                {{item.ukazy}}
              </span>
            </td>
            <td :rowspan="item.norm.length">
              <span v-if="item.notExecutedNorms > 0">
                {{ item.notExecutedNorms }}
              </span>
            </td>
          </template>
        </tr>

        <tr
          v-for="normItem in item.norm.slice(1)"
          :key="normItem.id"
        >
            <td>
              <span v-if="normItem.article">
                Статья {{ normItem.article.number }} <span v-if="normItem.article_part"> Ч.{{normItem.article_part}}</span>
              </span>
              {{ normItem.text }}
              <span class="d-block mt-2" v-if="normItem.law_changes_required && normItem.law_to_change">
                <span class="d-block">Требует внесения изменений в закон:</span>
                <b>
                  <router-link
                    :to="$i18nRoute({name: 'law-view', params: { id: normItem.law_to_change.id }})"
                  >
                    {{normItem.law_to_change.transName}}
                  </router-link>
                </b>
              </span>
            </td>
            <td>
              <div style="display:flex;flex-direction: column;"
                   v-for="developer in normItem.developers" :key="developer.id">
                <div style="display: flex; align-items: center;">
                  <span :class="{ 'font-weight-bold': developer.isMain }">{{ getDeveloperNameById(developer.id) }}</span>
                  <img
                    class="ml-1"
                    v-if="normItem.developers.length > 1 && developer.isMain"
                    width="16"
                    src="@/assets/icons/checked.png"
                  />
                </div>
              </div>
            </td>
            <td>
              <span v-if="normItem.implementationPeriod">
                {{ new Date(normItem.implementationPeriod ) | dateFormat('DD.MM.YYYY') }}
              </span>
            </td>
            <td>
              <span v-if="normItem.byLaw">
                {{ normItem.byLaw.transName }}
              </span>
              <span v-else>
                {{ $t('Нет') }}
              </span>
            </td>
          </tr>
      </template>

      <template v-else>
        <tr>
          <td>
            {{ item.id }}
          </td>
          <td>
            <template v-if="user">
              <router-link
                :title="item.transFullName | strippedContent"
                :to="$i18nRoute({name: 'law-view', params: { id: item.id }})"
              >
                {{ item.transFullName }}
              </router-link>
            </template>
            <template v-else>
              {{ item.transFullName }}
            </template>
          </td>
          <td>
            {{  item.adoptionDate }}
          </td>
          <td colspan="10">
            <span v-if="item.isExecNorm && item.executionOfLaw.id != 1">
              {{ item.executionOfLaw.transName }}
            </span>
          </td>
        </tr>
      </template>
      <template v-if="item.firstDeveloper">
        <tr v-for="firstDeveloperProject in item.firstDeveloper.projects" v-bind:key="item.id+item.firstDeveloper.id+firstDeveloperProject.id">
          <td>
            <template v-if="firstDeveloperProject.npaId">
              <router-link
                :title="firstDeveloperProject.transNpaName | strippedContent"
                :to="$i18nRoute({name: 'view-npa', params: { id: firstDeveloperProject.npaId }})"
                target="_blank"
              >
                {{ firstDeveloperProject.transNpaName }}
              </router-link>
            </template>
            <template v-else>
              {{ firstDeveloperProject.transNpaName }}
            </template>
          </td>
          <td>
            {{ firstDeveloperProject.stage }}
            <v-menu
              v-model="historiesMenu[firstDeveloperProject.id]"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              v-if="firstDeveloperProject.histories.length > 0"
            >
              <template v-slot:activator="{ on }">
                <a v-on="on">{{ $t('История') }}</a>
              </template>
              <v-list dense class="history-list">
                <v-list-item
                  v-for="history in firstDeveloperProject.histories"
                  :key="history.id"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ history.stage }} {{ history.createdDate }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
          <td>{{ firstDeveloperProject.note }}</td>
        </tr>
      </template>
      <template v-for="developer in item.developers">
        <tr v-bind:key="'dev_'+item.id+developer.id">
          <td :rowspan="developer.rowSpanProject">
            <template
              v-if="
                user &&
                (user.roleAdmin === true || user.roleSpecialist || user.roleDeveloper) &&
                inProgressStatus &&
                item.statusId === inProgressStatus
              "
            >
              <router-link
                :title="developer.developerTransName | strippedContent"
                :to="$i18nRoute({name: 'solution-edit', params: { id: developer.id }})"
              >
                <v-icon
                  v-if="developer.developerStatus === false"
                  class="nv_icon mr-1"
                  x-small
                />
                {{ developer.developerTransName }}
              </router-link>
            </template>
            <template v-else>
              <v-icon
                v-if="developer.developerStatus === false"
                class="nv_icon mr-1"
                x-small
              />
              {{ developer.developerTransName }}
            </template>
          </td>
          <td :rowspan="developer.rowSpanProject">
            {{ developer.solveNeeded ? $t("Требуется") : $t("Не требуется") }}
          </td>
          <template v-if="developer.firstProject">
            <td>
              <template v-if="developer.firstProject.npaId">
                <router-link
                  :title="developer.firstProject.transNpaName | strippedContent"
                  :to="$i18nRoute({name: 'view-npa', params: { id: developer.firstProject.npaId }})"
                  target="_blank"
                >
                  {{ developer.firstProject.transNpaName }}
                </router-link>
              </template>
              <template v-else>
                {{ developer.firstProject.transNpaName }}
              </template>
            </td>
            <td>
              {{ developer.firstProject.stage }}
              <v-menu
                v-model="historiesMenu[developer.firstProject.id]"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                v-if="developer.firstProject.histories.length > 0"
              >
                <template v-slot:activator="{ on }">
                  <a v-on="on">{{ $t('История') }}</a>
                </template>
                <v-list dense class="history-list">
                  <v-list-item
                    v-for="history in developer.firstProject.histories"
                    :key="history.id"
                    two-line
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ history.stage }} {{ history.createdDate }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td>{{ developer.firstProject.note }}</td>
          </template>
          <template v-else>
            <td></td>
            <td></td>
            <td></td>
          </template>
        </tr>
        <template v-if="developer.projects">
          <tr v-for="developerProject in developer.projects" v-bind:key="item.id+developer.id+developerProject.id">
            <td>
              <template v-if="developerProject.npaId">
                <router-link
                  :title="developerProject.transNpaName | strippedContent"
                  :to="$i18nRoute({name: 'view-npa', params: { id: developerProject.npaId }})"
                  target="_blank"
                >
                  {{ developerProject.transNpaName }}
                </router-link>
              </template>
              <template v-else>
                {{ developerProject.transNpaName }}
              </template>
            </td>
            <td>
              {{ developerProject.stage }}
              <v-menu
                v-model="historiesMenu[developerProject.id]"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
                v-if="developerProject.histories.length > 0"
              >
                <template v-slot:activator="{ on }">
                  <a v-on="on">{{ $t('История') }}</a>
                </template>
                <v-list dense class="history-list">
                  <v-list-item
                    v-for="history in developerProject.histories"
                    :key="history.id"
                    two-line
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ history.stage }} {{ history.createdDate }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td>{{ developerProject.note }}</td>
          </tr>
        </template>
      </template>
    </template>
    </tbody>
  </div>
</template>


<script>
  import Sorting from "@/components/app/Sorting";
  import { mapGetters } from "vuex";

  export default {
    name: 'LawTable',
    props: {
      lawItems: Array,
      user: Object,
      inProgressStatus: Number
    },
    components: {
      Sorting
    },
    data() {
      return {
        historiesMenu: {},
        data: {},
        orderBy: 'publishDate',
        orderDir: 'desc',
      }
    },
    computed: {
      ...mapGetters({
        searchData: 'getSearchData'
      }),
      tableHeaders () {
        const fields = [
            {
              name: this.$t('ID'), key: 'id',
              sorting: true,
              filterable: false,
              filterItems: this.data.refNpaView,
              colspan: 1
            },
            {
              name: this.$i18n.t('Сведение о Законе КР (наименование на двух языках, № от (дата принятия)'),
              key: 'name',
              sorting: true,
              colspan: 1
            },
            {
              name: this.$t('Дата принятия'),
              key: 'adoptionDate',
              sorting: true,
              filterable: false,
              filterItems: this.data.refDeveloper,
              colspan: 1
            },
          ]
          return fields
      },
      listLocal: {
        get() {
          return this.lawItems
        },
        set(newList) {
          this.$emit('update:lawItems', newList)
        }
      }
    },
    methods: {
      getDeveloperNameById (id) {
        let developer = this.searchData.refDeveloper.find(item => item.id == id)
        return developer != null ? developer.transName : ''
      },
      fetchData() {
        CMS.getNpaData().then((response) => {
          this.data = response.data
        });
      },
      sortData(sort) {
        this.$emit('order', sort)
      },
      cancelSorting(item) {
        this.$emit('cancelSorting', item.key)
      },

      sortingFilterHandler(filter) {
        this.$emit('filter', filter)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .law_enforcement {
    text-align: center;
    font-size: 16px;
  }
</style>
